"use strict";const e=require("styled-components").css`
    &.PlannerCard {
        padding: ${({theme:e})=>e.spacing.xlarge};
        box-shadow: ${({theme:e})=>e.shadows.low};
        border-radius: 4px;
        background: ${({theme:e})=>e.colors.common.light};

        .PlannerCard-content {
            display: grid;
            grid-row-gap: 20px;
            grid-template-rows: 160px auto auto;
            position: relative;

            @media (min-width: ${({theme:e})=>e.breakpoints.small}) {
                grid-row-gap: none;
                grid-template-columns: 160px auto ${({link:e})=>e?"64px":""};
                grid-template-rows: none;
                grid-column-gap: 50px;
                align-items: center;
            }

            .PlannerCard-icon > * {
                height: 100%;
                width: 160px;
            }

            .PlannerCard-info {
                .PlannerCard-heading {
                    margin: 0;
                }

                .PlannerCard-subheading {
                    margin-bottom: 0;
                }
            }

            .DXLinkArrow {
                width: 64px;
                height: 64px;
                background: rgb(0, 117, 201, 0.1);
                display: flex;
                justify-content: center;
                border-radius: 100%;
                margin-left: auto;
                position: unset;

                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }

                svg {
                    width: 22px;
                    height: 22px;
                    margin-left: 0;
                }

                svg path {
                    fill: ${({theme:e})=>e.colors.primary.default};
                }

                &:hover,
                &:active,
                &:focus {
                    svg {
                        transform: none;
                    }
                }
            }
        }

        .PlannerCard-children {
            border-top: 2px solid ${({theme:e})=>e.colors.grey[300]};
            padding-top: ${({theme:e})=>e.spacing.xlarge};
            margin-top: ${({theme:e})=>e.spacing.xlarge};

            > * {
                &:first-child {
                    margin-top: 0;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
